var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1.00195C13.7761 1.00195 14 0.778095 14 0.501953C14 0.256493 13.8231 0.0523458 13.5899 0.0100098L13.5 0.00195312H2.5C2.22386 0.00195312 2 0.225811 2 0.501953C2 0.747413 2.17688 0.951562 2.41012 0.993898L2.5 1.00195H13.5ZM8.00014 15.9997C8.2456 15.9997 8.4497 15.8227 8.49197 15.5895L8.5 15.4996L8.496 3.70574L12.1414 7.35408C12.3148 7.5278 12.5842 7.54734 12.7792 7.41252L12.8485 7.35473C13.0222 7.18132 13.0418 6.91192 12.907 6.71692L12.8492 6.64762L8.35745 2.14762C8.28495 2.07499 8.19568 2.02931 8.10207 2.01059L7.99608 2.00085C7.83511 2.00085 7.69192 2.07697 7.60051 2.19517L3.14386 6.64704C2.94846 6.84217 2.94823 7.15875 3.14336 7.35415C3.3168 7.52784 3.58621 7.54732 3.78117 7.41246L3.85046 7.35465L7.496 3.71374L7.5 15.4999C7.50008 15.776 7.724 15.9997 8.00014 15.9997Z",
    fill: "#2B1E70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/uploadImage.50db7e5f2f2d81cd0aaae4c40ab6404b.svg";
export { ForwardRef as ReactComponent };